import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiAuthService } from '../../../services/backend/public/api-auth/api-auth.service';

@Component({
  standalone: true,
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.css'
})
export class AuthCallbackComponent implements OnInit {
  private readonly auth = inject(ApiAuthService);
  private readonly router = inject(Router);
  ngOnInit(): void {
    this.auth.restore().subscribe({
      next: identity => { void this.router.navigateByUrl(identity.nextRoute ?? '/registro-inicial', { replaceUrl: true }); },
      error: error => { void this.router.navigate(['/inicio-sesion'], { queryParams: { auth_error: error.status === 503 ? 'unavailable' : 1 }, replaceUrl: true }); }
    });
  }
}
